import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";

/**
 * 网络请求辅助函数
 */
export default (({
  url,
  method = 'POST',
  headers = {
    'Content-Type': 'application/json'
  },
  query = null,
  body,
  beforeSend = null // 发送请求之前可通过此函数加入自定义处理

} = {}) => {
  if (!url) {
    return Promise.reject(new Error('URL 未设置'));
  }

  if (query) {
    const queries = [];
    Object.keys(query).forEach(key => {
      const value = query[key];

      if (value !== undefined) {
        queries.push(`${key}=${value}`);
      }
    });
    const queryStr = queries.join('&');
    url += url.includes('?') ? `&${queryStr}` : `?${queryStr}`;
  }

  const req = {
    method,
    url: url,
    // traditional: true,
    body,
    headers,
    credentials: 'include'
  };

  if (beforeSend) {
    beforeSend(req);
  }

  req.body = req.body ? JSON.stringify(body) : '';
  return fetch(url, req).then(res => res.json());
});